import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/site';

const T1 = 'https://readdy.ai/api/search-image?query=Breaking%20news%20alert%20with%20smartphone%20notification%20popup%2C%20glowing%20red%20screen%20in%20dark%20environment%2C%20urgent%20journalism%20concept%2C%20dramatic%20mood%20lighting%20with%20crimson%20tones%2C%20editorial%20photography%20with%20shallow%20depth%20of%20field%20and%20intense%20atmosphere&width=350&height=220&seq=track-01&orientation=landscape';
const T2 = 'https://readdy.ai/api/search-image?query=Social%20media%20feed%20scrolling%20on%20tablet%20device%20with%20scandal%20headlines%2C%20multiple%20notification%20badges%2C%20busy%20information%20overload%20concept%2C%20warm%20screen%20glow%20in%20dim%20room%2C%20modern%20digital%20journalism%20aesthetic&width=350&height=220&seq=track-02&orientation=landscape';
const T3 = 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20newspaper%20clippings%20revealing%20hidden%20text%2C%20investigative%20journalism%20concept%2C%20dramatic%20spotlight%20on%20key%20details%2C%20dark%20desk%20setting%20with%20warm%20amber%20lamp%20light%2C%20editorial%20mystery%20photography&width=350&height=220&seq=track-03&orientation=landscape';
const T4 = 'https://readdy.ai/api/search-image?query=Breaking%20news%20live%20broadcast%20studio%20with%20multiple%20screens%20showing%20different%20scandal%20feeds%2C%20professional%20newsroom%20atmosphere%2C%20dramatic%20studio%20lighting%20with%20red%20and%20white%20tones%2C%20fast-paced%20media%20production%20style&width=350&height=220&seq=track-04&orientation=landscape';
const T5 = 'https://readdy.ai/api/search-image?query=Anonymous%20whistleblower%20silhouette%20dropping%20documents%20into%20suggestion%20box%2C%20dramatic%20backlighting%20creating%20mystery%2C%20dark%20office%20corridor%20setting%2C%20intense%20editorial%20photography%20with%20hard%20light%20and%20deep%20shadows&width=350&height=220&seq=track-05&orientation=landscape';
const T6 = 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20gossip%20feed%20with%20multiple%20red%20notification%20badges%2C%20hand%20scrolling%20through%20content%2C%20blurred%20city%20night%20background%20through%20window%2C%20warm%20device%20glow%2C%20modern%20digital%20lifestyle%20editorial%20photography&width=350&height=220&seq=track-06&orientation=landscape';
const T7 = 'https://readdy.ai/api/search-image?query=Multiple%20security%20camera%20monitors%20in%20dark%20control%20room%20showing%20different%20scandal%20scenes%2C%20surveillance%20aesthetic%2C%20dramatic%20monitor%20glow%20in%20pitch%20black%20environment%2C%20cinematic%20thriller%20atmosphere&width=350&height=220&seq=track-07&orientation=landscape';
const T8 = 'https://readdy.ai/api/search-image?query=Typewriter%20with%20breaking%20news%20paper%20coming%20out%2C%20dramatic%20spotlight%20in%20dark%20newsroom%20setting%2C%20vintage%20journalism%20meets%20modern%20scandal%20concept%2C%20high%20contrast%20black%20and%20white%20with%20red%20accent%20lighting%2C%20editorial%20photography&width=350&height=220&seq=track-08&orientation=landscape';

const trackingImages = [T1, T2, T3, T4, T5, T6, T7, T8];

export default function RealTimeTracking() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -amount : amount,
        behavior: 'smooth',
      });
    }
  };

  const trackArticles = hotArticles.filter((a) => a.isNew || a.isHot);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-secondary-600 uppercase tracking-wide mb-2">
              <i className="ri-live-line"></i> 实时追踪
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">
              📡 黑料爆料实时追踪
            </h2>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-600 hover:bg-foreground-100 hover:text-foreground-900 transition-colors cursor-pointer"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-600 hover:bg-foreground-100 hover:text-foreground-900 transition-colors cursor-pointer"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 overflow-x-auto pb-2"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {trackArticles.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="flex-shrink-0 w-[280px] group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all"
            >
              <div className="relative h-40">
                <img
                  src={trackingImages[idx % trackingImages.length]}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
                <div className="absolute top-2 right-2">
                  {article.isNew ? (
                    <span className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-accent-500 text-white whitespace-nowrap">
                      NEW
                    </span>
                  ) : (
                    <span className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-primary-500 text-white whitespace-nowrap">
                      HOT
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4">
                <span className="text-[10px] font-semibold text-primary-600 uppercase tracking-wide">
                  {article.category}
                </span>
                <h3 className="font-semibold text-sm text-foreground-900 mt-1.5 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
                  <span className="whitespace-nowrap">{article.date}</span>
                  <span className="flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line text-[10px]"></i> {article.views.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}